import {
  ColumnConfiguration,
  ColumnConfigurationRenderAs,
} from '@april9au/stack9-sdk';

import { ListTable } from '../../components/ListTable/ListTable';
import { SurveyQuestionDrawerAction } from '../../components/ListViewCustomComponents';
import { SurveyQuestion } from '../../models/stack9/SurveyQuestion';

type Props = {
  countryTemplateId: number;
  initialValues?: Partial<SurveyQuestion>;
};

const Drawer = SurveyQuestionDrawerAction.default;

const SurveyQuestionInfo = ({ countryTemplateId, initialValues }: Props) => {
  const columns: ColumnConfiguration[] = [
    {
      label: 'Code',
      field: 'code',
      renderAs: ColumnConfigurationRenderAs.CustomComponent,
      value: '{{code}}',
      options: {
        customComponentName: 'SurveyQuestionDrawerAction',
      },
    },
    {
      label: 'Question',
      field: 'question',
      renderAs: ColumnConfigurationRenderAs.Text,
      value: '{{question}}',
    },
    {
      label: 'Sequence',
      field: 'sequence',
      renderAs: ColumnConfigurationRenderAs.Text,
      value: '{{sequence}}',
    },
    {
      label: 'Is active',
      field: 'is_active',
      renderAs: ColumnConfigurationRenderAs.EnumTags,
      value: '{{is_active}}',
      options: {
        enumColor: {
          Yes: 'green',
          No: 'red',
        },
      },
    },
  ];

  return (
    <ListTable
      queryVars={{ countryTemplateId }}
      columns={columns}
      title="Survey Questions"
      queryName="getsurveyquestionsbycountrytemplate"
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'end',
          marginBottom: '15px',
        }}
      >
        <Drawer row={{ ...initialValues }} />
      </div>
    </ListTable>
  );
};

export default SurveyQuestionInfo;
